import { FC, useEffect, useState } from "react";
import { Release } from "models/release";
import ReleaseExtensionRows from "./ReleaseExtensionRows";

type ReleaseTableProps = {
    releases: Release[];
    onReleaseSelect: (release: Release) => void;
    selectedRelease: Release | null;
};

const uniqueExtensions = (releases: Release[]) => {
    const unique = new Set(releases.map((r) => r.extension));
    return Array.from(unique);
};

const ReleaseTable: FC<ReleaseTableProps> = ({
    releases,
    onReleaseSelect,
    selectedRelease,
}) => {
    const [extensions, setExtensions] = useState<string[]>([]);

    useEffect(() => {
        setExtensions(uniqueExtensions(releases));
    }, [releases]);

    return (
        <div className="table-responsive pb-4">
            <table
                className="table table-bordered table-striped table-hover mb-0"
                style={{ padding: "1em" }}
            >
                <thead>
                    <tr>
                        <th scope="col"></th>
                        <th className="col-3" scope="col">
                            Release
                        </th>
                        <th className="col-1" scope="col">
                            Versie
                        </th>
                        <th className="col-8" scope="col">
                            Bestanden
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {extensions.map((extension) => (
                        <ReleaseExtensionRows
                            key={extension}
                            releases={releases.filter(
                                (r) => r.extension === extension
                            )}
                            onReleaseSelect={onReleaseSelect}
                            selectedRelease={selectedRelease}
                        />
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default ReleaseTable;
